import React from 'react';
import { steps } from '../mock';
import { Award, Mail, Target, TrendingUp, Sparkles, CheckCircle2 } from 'lucide-react';

const iconMap = { Award, Mail, Target, TrendingUp };

export default function HowItWorks() {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-emerald-500/30 bg-emerald-500/5 text-emerald-300 text-xs font-semibold">
            <Sparkles size={12} /> Simple Process
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl font-extrabold text-white tracking-tight">
            How It Works
          </h2>
          <p className="mt-3 text-slate-400">4 simple steps to start your exam preparation journey</p>
        </div>

        <div className="relative grid md:grid-cols-4 gap-6">
          {steps.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.step}
                className="relative rounded-xl border border-white/5 bg-[#0f1725] p-6 text-center hover:border-emerald-500/40 transition-colors"
              >
                <div className="w-16 h-16 mx-auto rounded-full bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center mb-5 shadow-lg shadow-emerald-500/20">
                  <Icon className="text-slate-900" size={26} />
                </div>
                <div className="text-emerald-400 text-sm font-semibold">{s.step}</div>
                <h3 className="mt-2 text-white font-bold text-lg">{s.title}</h3>
                <p className="mt-3 text-slate-400 text-sm leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-2xl border border-emerald-500/20 bg-emerald-500/5 p-6 flex items-start gap-3">
          <CheckCircle2 className="text-emerald-400 flex-shrink-0 mt-0.5" size={20} />
          <div>
            <h4 className="text-white font-bold flex items-center gap-2">
              <Target size={16} className="text-emerald-400" /> Maximum Flexibility
            </h4>
            <p className="mt-1 text-slate-300 text-sm leading-relaxed">
              Pehle pass buy karein, baad mein exam decide karein! Aap purchase ke baad kisi bhi time apna exam choose kar sakte hain. Abhi decide karne ki zarurat nahi hai.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
